import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import GoogleMapsLoader from './apis/GoogleMapsLoader';

ReactDOM.render(
  <React.Fragment>
    <GoogleMapsLoader>
      <App />
    </GoogleMapsLoader>
  </React.Fragment>,
  document.getElementById('root')
);
